// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetAppARProtocolData = (protocolId) => {
  const protocolImg = importImages(require.context("../../../../assets/images/protocols/reports/app/ar", false, /\.(png|jpe?g|svg)$/));

  const protocolsData = {
    [protocols.app.ar.TRAINING.id]: {
      img: protocolImg["./training.png"],
      imgResponsive: protocolImg["./training_responsive.png"],
      name: "uppercaseProtocols_training",
      description: "protocols_trainingDescription",
      video: "protocols_trainingVideo",
    },
    [protocols.app.ar.SHELVES.id]: {
      img: protocolImg["./shelves.png"],
      imgResponsive: protocolImg["./shelves_responsive.png"],
      name: "uppercaseProtocols_shelves",
      description: "protocols_shelvesDescription",
      video: "protocols_shelvesVideo",
    },
    [protocols.app.ar.BUFFET.id]: {
      img: protocolImg["./buffet.png"],
      imgResponsive: protocolImg["./buffet_responsive.png"],
      name: "uppercaseProtocols_buffet",
      description: "protocols_buffetDescription",
      video: "protocols_buffetVideo",
    },
    [protocols.app.ar.ALPHABET.id]: {
      img: protocolImg["./alphabet.png"],
      imgResponsive: protocolImg["./alphabet_responsive.png"],
      name: "uppercaseProtocols_alphabet",
      description: "protocols_alphabetDescription",
      video: "protocols_alphabetVideo",
    },
    [protocols.app.ar.BALLOONS.id]: {
      img: protocolImg["./balloons.png"],
      imgResponsive: protocolImg["./balloons_responsive.png"],
      name: "uppercaseProtocols_balloons",
      description: "protocols_balloonsDescription",
      video: "protocols_balloonsVideo",
    },
    [protocols.app.ar.DUCKS.id]: {
      img: protocolImg["./ducks.png"],
      imgResponsive: protocolImg["./ducks_responsive.png"],
      name: "uppercaseProtocols_ducks",
      description: "protocols_ducksDescription",
      video: "protocols_ducksVideo",
    },
    [protocols.app.ar.SPHEROIDS.id]: {
      img: protocolImg["./spheroids.png"],
      imgResponsive: protocolImg["./spheroids_responsive.png"],
      name: "uppercaseProtocols_spheroidsAR",
      description: "protocols_spheroidsARDescription",
      video: "protocols_spheroidsARVideo",
    },
    [protocols.app.ar.HOCKEY.id]: {
      img: protocolImg["./hockey.png"],
      imgResponsive: protocolImg["./hockey_responsive.png"],
      name: "uppercaseProtocols_hockeyAR",
      description: "protocols_hockeyARDescription",
      video: "protocols_hockeyARVideo",
    },
    [protocols.app.ar.CIRCLE.id]: {
      img: protocolImg["./circle_vertical.png"],
      imgResponsive: protocolImg["./circle_vertical_responsive.png"],
      name: "uppercaseProtocols_circle",
      description: "protocols_circleDescription",
      video: "protocols_circleVideo",
    },
    [protocols.app.ar.WHAC_A_MOLE.id]: {
      img: protocolImg["./whac_a_mole.png"],
      imgResponsive: protocolImg["./whac_a_mole_responsive.png"],
      name: "uppercaseProtocols_whackAMoleAR",
      description: "protocols_whackAMoleARDescription",
      video: "protocols_whackAMoleARVideo",
    },
    [protocols.app.ar.TUBES.id]: {
      img: protocolImg["./tubes.png"],
      imgResponsive: protocolImg["./tubes_responsive.png"],
      name: "uppercaseProtocols_tubes",
      description: "protocols_tubesDescription",
      video: "protocols_tubesVideo",
    },
    [protocols.app.ar.CLEANING_AR.id]: {
      img: protocolImg["./cleaning_horizontal.png"],
      imgResponsive: protocolImg["./cleaning_horizontal_responsive.png"],
      name: "uppercaseProtocols_cleaningAR",
      description: "protocols_cleaningARDescription",
      video: "protocols_cleaningARVideo",
    },
    [protocols.app.ar.CLEANING_AR_VERTICAL.id]: {
      img: protocolImg["./cleaning_vertical.png"],
      imgResponsive: protocolImg["./cleaning_vertical_responsive.png"],
      name: "uppercaseProtocols_cleaningARVertical",
      description: "protocols_cleaningARVerticalDescription",
      video: "protocols_cleaningARVerticalVideo",
    },
    [protocols.app.ar.CIRCLE_HORIZONTAL.id]: {
      img: protocolImg["./circle_horizontal.png"],
      imgResponsive: protocolImg["./circle_horizontal_responsive.png"],
      name: "uppercaseProtocols_circleHorizontal",
      description: "protocols_circleHorizontalDescription",
      video: "protocols_circleHorizontalVideo",
    },
    [protocols.app.ar.QUALITY_CONTROL.id]: {
      img: protocolImg["./quality_control.png"],
      imgResponsive: protocolImg["./quality_control_responsive.png"],
      name: "uppercaseProtocols_qualityControl",
      description: "protocols_qualityControlDescription",
      video: "protocols_qualityControlVideo",
    },
    [protocols.app.ar.CONSTELLATIONS_AR.id]: {
      img: protocolImg["./constellations.png"],
      imgResponsive: protocolImg["./constellations_responsive.png"],
      name: "uppercaseProtocols_constellationsAR",
      description: "protocols_constellationsARDescription",
      video: "protocols_constellationsARVideo",
    },
  };

  return protocolsData[Number(protocolId)];
};
